module.exports = __webpack_public_path__ + "static/media/dpe2.png.79946ddc.jpg";